module.exports = __webpack_public_path__ + "img/bg-wallet-success-modal-light.a73c1888.png";